import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Brief route-transition overlay: a thin horizontal sweep that plays each time
 * the pathname changes. Subtle and never blocks input (pointer-events-none).
 */
export default function PageTransition() {
  const { pathname } = useLocation();
  const [animKey, setAnimKey] = useState(0);

  useEffect(() => {
    setAnimKey((k) => k + 1);
  }, [pathname]);

  return (
    <div
      key={animKey}
      className="fixed top-0 left-0 right-0 h-[1px] z-[95] pointer-events-none overflow-hidden"
      aria-hidden="true"
    >
      <div className="page-transition-bar" />
      <style>{`
        .page-transition-bar {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, transparent 0%, rgba(182,198,241,0.7) 50%, transparent 100%);
          transform: translateX(-100%);
          animation: pt-sweep 1.1s cubic-bezier(0.16,1,0.3,1) forwards;
        }
        @keyframes pt-sweep {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
